import React from 'react';
import { Post } from 'lib/types/posts';
import { imagePostUrl } from 'lib/utils/imageUtils';
import { getTop } from './utils';

export interface Slide4Props {
  topPost: Post;
}

/** Slide 4 - Top post */
export const Slide04 = ({
  topPost,
}: Slide4Props) => {
  const top = getTop(topPost);

  return (
    <div className="absolute inset-0 text-white text-center w-full h-full">
      <div className="absolute top-[45%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 flex flex-col items-center">
        <img
          alt="Top post"
          className="animate-flydown"
          src={imagePostUrl(topPost.thumbnailUrl, {
            isDead: !topPost.isLive,
            height: 300,
          })}
        />
        <div className="mt-1 font-extralight text-xs animate-flydown">
          @
          {topPost.account}
          {' '}
          on
          {' '}
          {new Date(topPost.postedAt).toLocaleDateString(undefined, {
            month: '2-digit',
            day: '2-digit',
            year: '2-digit',
          }).replace(/\//g, '.')}
        </div>
      </div>
      <div className="absolute top-[70%] left-1/2 -translate-x-1/2">
        <div className="text-8xl font-extrabold leading-none">
          {top.count}
        </div>
        <div className="">
          <div className="text-2xl font-light">
            {top.text}
          </div>
        </div>
      </div>
    </div>
  );
};
